var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconOpacityFilled = function SvgIconOpacityFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.17c-1.78 0-3.294-.617-4.544-1.848-1.25-1.231-1.875-2.724-1.875-4.479 0-.86.16-1.667.48-2.42a6.316 6.316 0 0 1 1.324-1.985L9.09 2.693c.127-.131.267-.228.42-.29.151-.062.315-.093.49-.093.177 0 .34.03.493.093.152.062.291.159.42.29l3.723 3.766a6.542 6.542 0 0 1 1.303 1.973c.32.748.481 1.551.481 2.411 0 1.755-.625 3.248-1.875 4.48-1.25 1.23-2.765 1.846-4.544 1.846ZM5.33 11h9.35a6.672 6.672 0 0 0-.272-1.755c-.16-.524-.477-1.028-.95-1.515L10 4.23 6.562 7.71c-.486.486-.808.994-.968 1.524A6.736 6.736 0 0 0 5.331 11Z",
    fill: "current"
  })));
};
export default SvgIconOpacityFilled;